
export default {
  methods: {
    checkIfCacheStorageIsEmpty () {
      return new Promise((resolve, reject) => {
        window.caches.keys()
          .then((array) => {
            resolve(array.length === 0)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
}
